import { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/app/store/authStore';
import { Layout } from '@/shared/components/Layout';
import { LoginForm } from '@/features/dashboard/components/LoginForm';
import { ConfirmEmail } from '@/features/auth/components/ConfirmEmail';
import { ConfirmEmailChange } from '@/features/auth/components/ConfirmEmailChange';
import { ForgotPassword } from '@/features/auth/components/ForgotPassword';
import { ResetPassword } from '@/features/auth/components/ResetPassword';
import { AddUserForm } from '@/features/admin/components/AddUserForm';
import { AdminPanel } from '@/features/admin/components/AdminPanel';
import { Dashboard } from '@/features/dashboard/components/Dashboard';
import { FeedList } from '@/features/rss-feeds/components/FeedList';
import { Settings } from '@/features/settings/components/Settings';
import { Export } from '@/features/export/components/Export';
import { Productboard } from '@/features/productboard/components/Productboard';
import { Clients } from '@/features/clients/components/Clients';
import { TaskBoard } from '@/features/tasks/components/TaskBoard';

import { ProtectedRoute } from '@/shared/components/ProtectedRoute/ProtectedRoute';
import { AdminRoute } from '@/shared/components/AdminRoute/AdminRoute';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';

function App() {
  const { initializeAuth } = useAuthStore();
  const initialized = useRef(false);

  useEffect(() => {
    // Guard against React StrictMode's double-invoke so the boot refresh fires once.
    if (initialized.current) return;
    initialized.current = true;
    // On app start, recover the session via a silent cookie-based refresh.
    initializeAuth();
  }, [initializeAuth]);

  return (
    <Router>
      <div className="App">
        <ErrorBoundary>
        <Routes>
          <Route path="/login" element={<LoginForm />} />
          <Route path="/confirm-email" element={<ConfirmEmail />} />
          <Route path="/confirm-email-change" element={<ConfirmEmailChange />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/"
            element={<ProtectedRoute><Layout /></ProtectedRoute>}
          >
            <Route index element={<Dashboard />} />
            <Route path="feeds" element={<FeedList />} />
            <Route path="productboard" element={<Productboard />} />
            <Route path="clients" element={<Clients />} />
            <Route path="tasks" element={<TaskBoard />} />
            <Route path="settings" element={<Settings />} />
            <Route path="export" element={<Export />} />
            <Route path="admin" element={<AdminRoute><AdminPanel /></AdminRoute>} />
            <Route path="users/new" element={<AdminRoute><AddUserForm /></AdminRoute>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </ErrorBoundary>

      </div>
    </Router>
  );
}

export default App;